/* GMU home (T3). gmu-fabric: colour swatches filter the Italian styles grid in place
   (by SKU colour code when the swatch has data-codes, else by colour name).
   One card per style, 4 visible. Pressing the active swatch again resets the row.
   Status text per colour is rendered server-side (translated) in data-status. */
(function () {
  if (customElements.get('gmu-fabric')) return;

  class GmuFabric extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.gmu-fabric__grid > li'));
      this.btns = Array.from(this.querySelectorAll('[data-c]'));
      this.status = this.querySelector('.gmu-fabric__status');
      this.max = 4;
      this.btns.forEach((b) => {
        b.addEventListener('click', () => {
          const c = b.dataset.c;
          this.pick(b.getAttribute('aria-pressed') === 'true' && c !== 'all' ? 'all' : c);
        });
      });
    }

    pick(c) {
      const seen = new Set();
      const btn = this.btns.find((x) => x.dataset.c === c);
      const codes = btn && btn.dataset.codes;
      const match = (li) => c === 'all' || (codes ? codes.includes(',' + li.dataset.code + ',') : li.dataset.colour === c);
      this.items.forEach((li) => {
        const ok = match(li) && !seen.has(li.dataset.style) && seen.size < this.max;
        if (ok) seen.add(li.dataset.style);
        li.hidden = !ok;
      });
      let status = '';
      this.btns.forEach((b) => {
        const on = b.dataset.c === c;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && c !== 'all') status = b.dataset.status || '';
      });
      if (this.status) this.status.textContent = status;
    }
  }

  customElements.define('gmu-fabric', GmuFabric);
})();
